<template>
<div class="ui segments">
  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Konta papildināšana</div>
    </div>
  </div>

  <div class="ui segment">

    <!-- show in case payment status is not yet confirmed -->
    <div class="ui warning icon message" v-if="paymentData.status == 2 || paymentData.status == 0">
      <i class="info circle icon"></i>
      <div class="content">
        <div class="header">
          Informācijai
        </div>
        <p>Samaksas process vēl nav pabeigts. Atkarībā no bankas šis process var aizņemt dažas stundas. <br> Tiklīdz maksājums tiks apstiprināts, Jūs saņemsiet e-pastu no maksājumu sistēmas</p>
      </div>
    </div>

    <!-- show this if payment is confirmed -->
    <div class="ui positive icon message" v-if="paymentData.status == 1">
      <i class="checkmark icon"></i>
      <div class="content">
        <div class="header">
          Konts ir papildināts
        </div>
        <p>Pavadzīmi par konta papildināšanu variet apskatīt
          <router-link :to="{name:'user-bills'}">šeit</router-link>
        </p>
      </div>
    </div>

    <!-- show this if payment is NOT confirmed -->
    <div class="ui error icon message" v-if="paymentData.payment_status == 'PENDING' || paymentData.payment_status == 'ABANDONED'">
      <i class="warning sign icon"></i>
      <div class="content">
        <div class="header">
          Uzmanību!
        </div>
        <p>Maksājums nav apstiprināts</p>
      </div>
    </div>

    <!-- reusable -->
    <div class="ui form">
      <div class="grouped fields">
        <div>Jūsu konta atlikums ir <b>{{user.balance}} &euro;</b> papildināt ar:</div>

        <div v-for="item in paymentMethods" class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="payment_type" v-model="method" :value="item.id" :id="item.id" number>
            <label :for="item.id">
              <b>{{item.name}}</b>
              <span class="ms-small-txt" v-if="item.charge > 0" >(pasūtījuma apstrādes maksa {{item.charge}} EUR)</span>
              <a v-if="item.url" :href="item.url" target="blank">({{item.urlText}})</a>
            </label>
          </div>
        </div>
      </div>
      <div class="inline fields">
        <div>Papildināt kontu par &nbsp; </div>
        <div class="field">
          <input type="number" step="0.01" v-model="amount" number> &euro;
        </div>
        <button v-on:click="topuAccount" v-bind:class="{ loading: showLoading }" class="ui floated custom_brown button" :disabled="amount == '' || amount <= 0">Papildināt</button>
      </div>
    </div>
    <!-- end of reusable -->
  </div>

</div>
</template>

<script>
export default {
  data() {
    return {
      method: 6,
      amount: '',
      showLoading: false, //will use local state so that user still sees loading icon while windows method is opening new url
      isActive: false,
      paymentMethods: [{
        id: 6,
        name: 'Bankas maksājumu karti (VISA/Mastercard)',
        charge: '0.30'
      }, {
        id: 7,
        name: 'SEB internetbanku',
        charge: '0.50'
      }, {
        id: 8,
        name: 'Citadele internetbanku',
        charge: '0.50'
      }, {
        id: 9,
        name: 'Luminor internetbanku',
        charge: '0.50'
      }, {
        id: 10,
        name: 'Swedbank internetbanku',
        charge: '0.50'
      }, {
        id: 11,
        name: 'Revolut internetbanku',
        charge: '0.50'
      }]
    }
  },
  computed: {
    user() {
      return this.$store.state.userStore.user
    },

    paymentUrl() {
      return this.$store.state.paymentStore.paymentUrl
    },
    paymentData() {
      return this.$store.state.paymentStore.paymentData
    }
  },


  activated: function() {
    this.showLoading = false; //reset
    this.isActive = true;
    //if balance is negative then set it to amount
    this.$store.dispatch('loadUser').then((response) => {
      if (this.user.balance < 0) this.amount = (this.user.balance * (-1)).toFixed(2)
      else this.amount = '';
    });

    this.loadPaymentStatus();
  },

  deactivated: function() {
    this.isActive = false;
  },

  watch: {
    '$route.params': 'loadPaymentStatus',
  },

  methods: {
    topuAccount: function() {
      this.showLoading = true;

      var data = {
        topup: this.amount,
        method: this.method
      };

      this.$store.dispatch('addPayment', data).then((response) => {

        window.location.href = this.paymentUrl

      }).catch((error) => {
        this.showLoading = false; //todo - add error
      });
    },

    loadPaymentStatus: function() {

      //check if param is set, if yes then load it
      if (this.isActive && this.$route.params.payment_id) this.$store.dispatch('loadPayment', this.$route.params.payment_id)

    }
  }
}
</script>

<style>
.ui.checkbox label .ms-small-txt,
.ui.checkbox+label .ms-small-txt {
  font-size: 13px !important
}
</style>



// WEBPACK FOOTER //
// TopUpAccountPage.vue?edfa9194